import { Component } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-faq',
  imports: [HeaderComponent, FooterComponent, CommonModule, TranslateModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  faqItems = [
    {
      question: 'FAQ_PAGE.ITEMS.Q1',
      answer: 'FAQ_PAGE.ITEMS.A1',
      isOpen: false,
    },
    {
      question: 'FAQ_PAGE.ITEMS.Q2',
      answer: 'FAQ_PAGE.ITEMS.A2',
      isOpen: false,
    },
    {
      question: 'FAQ_PAGE.ITEMS.Q3',
      answer: 'FAQ_PAGE.ITEMS.A3',
      isOpen: false,
    },
    {
      question: 'FAQ_PAGE.ITEMS.Q4',
      answer: 'FAQ_PAGE.ITEMS.A4',
      isOpen: false,
    },
    {
      question: 'FAQ_PAGE.ITEMS.Q5',
      answer: 'FAQ_PAGE.ITEMS.A5',
      isOpen: false,
    },
    {
      question: 'FAQ_PAGE.ITEMS.Q6',
      answer: 'FAQ_PAGE.ITEMS.A6',
      isOpen: false,
    },
  ];

  toggleFaq(index: number): void {
    this.faqItems[index].isOpen = !this.faqItems[index].isOpen;
  }
}
